"use client";

import { useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import { BiWorld } from "react-icons/bi";
import useTranslation from "@/hook/useTranslation";

const LanguageSwitcher = () => {
  const [showDropdown, setShowDropdown] = useState(false); // Track dropdown visibility
  const router = useRouter();
  const pathname = usePathname();
  const { t, locale } = useTranslation();

  const languages = [
    { code: "en", label: "English" },
    { code: "th", label: "ไทย" },
    { code: "zh", label: "中文" },
  ];

  const changeLanguage = (newLocale) => {
    const segments = pathname.split("/");
    segments[1] = newLocale;

    const newPathname = segments.join("/");
    router.push(newPathname);
    setShowDropdown(false);
  };

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  return (
    <div className="language-container">
      <div className="language-switcher">
        <BiWorld
          size={32}
          style={{ color: "#384454", cursor: "pointer" }}
          onClick={toggleDropdown}
        />

        {showDropdown && (
          <div className="dropdown-list">
            {languages.map((lang) => {
              if (lang.code != locale) {
                return (
                  <div
                    key={lang.code}
                    onClick={() => changeLanguage(lang.code)}
                    className="px-4 py-2 cursor-pointer hover:bg-gray-200"
                  >
                    {lang.label}
                  </div>
                );
              }
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
